import { useCallback, useEffect, useRef } from 'react';
import SearchResults from '../SearchResults';
import RecentItems from './components/RecentItems';
import {
  Overlay,
  Card,
  InputRow,
  SearchIconWrap,
  Input,
  RightSlot,
  ClearBtn,
  CloseBtn,
  ResultsArea,
} from './styles';

interface ComponentProps {
  query: string;
  onChange: (value: string) => void;
  onClose: () => void;
  toolbarHeight?: number;
}

const SearchModal = ({ query, onChange, onClose, toolbarHeight = 0 }: ComponentProps) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const isSearchActive = query.trim().length >= 2;

  useEffect(() => {
    inputRef.current?.focus();
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, []);

  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);

  const handleOverlayClick = useCallback(
    (e: React.MouseEvent<HTMLDivElement>) => {
      if (e.target === e.currentTarget) onClose();
    },
    [onClose]
  );

  return (
    <Overlay onClick={handleOverlayClick} $mobileTopOffset={toolbarHeight + 60}>
      <Card>
        <InputRow>
          <SearchIconWrap>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="11" cy="11" r="8" />
              <line x1="21" y1="21" x2="16.65" y2="16.65" />
            </svg>
          </SearchIconWrap>

          <Input
            ref={inputRef}
            type="text"
            value={query}
            placeholder="Buscar artículos, encuentros y categorías..."
            onChange={(e) => onChange(e.target.value)}
            autoComplete="off"
            spellCheck={false}
          />

          <RightSlot>
            {query && (
              <ClearBtn
                type="button"
                onMouseDown={(e) => {
                  e.preventDefault();
                  onChange('');
                }}
                aria-label="Limpiar búsqueda"
              >
                ✕
              </ClearBtn>
            )}
            <CloseBtn type="button" onClick={onClose} aria-label="Cerrar búsqueda">
              <span className="desktop-label">ESC</span>
              <span className="mobile-label">Cancelar</span>
            </CloseBtn>
          </RightSlot>
        </InputRow>

        {isSearchActive ? (
          <ResultsArea>
            <SearchResults query={query} />
          </ResultsArea>
        ) : (
          <ResultsArea>
            <RecentItems />
          </ResultsArea>
        )}
      </Card>
    </Overlay>
  );
};

export default SearchModal;
